import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-my-account-skeleton-loading',
  standalone: true,
  imports: [NgxSkeletonLoaderModule, MatCardModule, MatDividerModule],
  templateUrl: './my-account-skeleton-loading.component.html',
  styleUrl: './my-account-skeleton-loading.component.css'
})
export class MyAccountSkeletonLoadingComponent {

}
